import styled from '@emotion/styled';
import { Fragment, useState } from 'react';

import BannerFooter from './BannerFooter';
import BannerIndicator from './BannerIndicator';
import BannerList from './BannerList';
import usePopupBanners from './hooks/usePopupBanners';
import usePopupHide from './hooks/usePopupHide';

function PopupBanners() {
    const { banners } = usePopupBanners();
    const [index, setIndex] = useState<number>(0);
    const {
        isHide, hide, hideToday, isNone, isTodayHidden,
    } = usePopupHide();
    if (banners && banners?.length !== 0) {
        return (
            <Dim isHide={isHide}
                isNone={isNone}>
                <Container isHide={isHide}>
                    <BannerList setIndex={setIndex} banners={banners} />
                    <BannerIndicator index={index}
                        banners={banners} />
                    <BannerFooter hide={hide}
                        hideToday={hideToday}
                        isTodayHidden={isTodayHidden} />
                </Container>
            </Dim>
        );
    }
    return (<Fragment/>);
}

const Dim = styled.div<{
  isHide: boolean;
  isNone: boolean;
}>`
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 3;
    background-color: rgba(0, 0, 0, 0.65);
    display: ${(props) => (props.isNone ? 'none' : 'flex')};
    flex-direction: column;
    justify-content: flex-end;
    transition: 350ms;
    opacity: ${(props) => (props.isHide ? 0 : 1)};
`;

const Container = styled.div<{isHide: boolean}>`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 350ms;
  transform: translateY(${(props) => (props.isHide ? '100%' : '0')});
    border-radius: 16px 16px 0 0;
    overflow: hidden;
`;

export default PopupBanners;
